import * as i0 from '@angular/core';
import { isDevMode, Directive, Input, Component, NgModule, Injectable } from '@angular/core';
import { isOn, set } from 'feature-toggle-service';
import { CommonModule } from '@angular/common';
import * as i1 from '@angular/router';
const _c0 = ["*"];
let FeatureToggleDirective = /*#__PURE__*/(() => {
  class FeatureToggleDirective {
    constructor(templateRef, viewContainer) {
      this.templateRef = templateRef;
      this.viewContainer = viewContainer;
      this.isOn = false;
    }
    ngOnInit() {
      if (!this.featureToggle) {
        throw new Error('Attribute `featureToggle` should not be null or empty');
      }
      this.shouldRender();
    }
    ngDoCheck() {
      if (this.isOn !== this.isOnCheck(this.featureToggle)) {
        this.shouldRender();
      }
    }
    shouldRender() {
      this.isOn = this.isOnCheck(this.featureToggle);
      if (this.isOn) {
        this.viewContainer.createEmbeddedView(this.templateRef);
      } else {
        this.viewContainer.clear();
      }
    }
    isOnCheck(featureToggle) {
      if (typeof featureToggle !== 'string' && !Array.isArray(featureToggle)) {
        if (isDevMode()) {
          console.error('`NgxFeatureToggle`: `featureToggle` should receive an array or an string as a value.');
        }
        return false;
      }
      return [].concat(featureToggle).every(toggle => toggle[0] === '!' ? !isOn(toggle.replace('!', '')) : isOn(toggle));
    }
  }
  /** @nocollapse */
  /** @nocollapse */FeatureToggleDirective.ɵfac = function FeatureToggleDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || FeatureToggleDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef), i0.ɵɵdirectiveInject(i0.ViewContainerRef));
  };
  FeatureToggleDirective.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: FeatureToggleDirective,
    selectors: [["", "featureToggle", ""]],
    inputs: {
      featureToggle: "featureToggle"
    },
    standalone: false
  });
  return FeatureToggleDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FeatureToggleProviderComponent = /*#__PURE__*/(() => {
  class FeatureToggleProviderComponent {
    constructor() {
      this.features = {};
      this.currentConfig = {};
    }
    ngOnInit() {
      if (typeof this.features !== 'object') {
        throw new Error('Attribute `features` should not be null or empty');
      }
      this.setFeatureToggles();
    }
    ngDoCheck() {
      this.setFeatureToggles();
    }
    setFeatureToggles() {
      if (this.currentConfig !== this.features) {
        // Using `Object.assign()` method for bundle size decreasing purposes
        // It's required since it needs a new memory reference
        // for the new object value
        this.currentConfig = Object.assign({}, this.features);
        set(this.features);
      }
    }
  }
  /** @nocollapse */
  /** @nocollapse */FeatureToggleProviderComponent.ɵfac = function FeatureToggleProviderComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || FeatureToggleProviderComponent)();
  };
  FeatureToggleProviderComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: FeatureToggleProviderComponent,
    selectors: [["feature-toggle-provider"]],
    inputs: {
      features: "features"
    },
    standalone: false,
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function FeatureToggleProviderComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    encapsulation: 2
  });
  return FeatureToggleProviderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FeatureToggleModule = /*#__PURE__*/(() => {
  class FeatureToggleModule {}
  /** @nocollapse */
  /** @nocollapse */
  /** @nocollapse */FeatureToggleModule.ɵfac = function FeatureToggleModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || FeatureToggleModule)();
  };
  FeatureToggleModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: FeatureToggleModule
  });
  FeatureToggleModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [CommonModule]
  });
  return FeatureToggleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NgxFeatureToggleRouteGuard = /*#__PURE__*/(() => {
  class NgxFeatureToggleRouteGuard {
    constructor(router) {
      this.router = router;
    }
    isDevMode() {
      return isDevMode();
    }
    isOnCheck(route) {
      if (!route || !route.data || typeof route.data.featureToggle !== 'string' && !Array.isArray(route.data.featureToggle)) {
        if (this.isDevMode()) {
          console.error(
          // tslint:disable-next-line: max-line-length
          '`NgxFeatureToggleRouteGuard` need to receive `featureToggle` as data as an array or string in your route configuration.');
        }
        return false;
      }
      const hasAllTogglesOn = [].concat(route.data.featureToggle).every(toggle => toggle[0] === '!' ? !isOn(toggle.replace('!', '')) : isOn(toggle));
      if (!hasAllTogglesOn && route.data.redirectTo) {
        this.router.navigate([].concat(route.data.redirectTo));
      }
      return hasAllTogglesOn;
    }
    canLoad(route) {
      return this.isOnCheck(route);
    }
    canActivateChild(route) {
      return this.isOnCheck(route);
    }
    canActivate(route) {
      return this.isOnCheck(route);
    }
  }
  /** @nocollapse */
  /** @nocollapse */NgxFeatureToggleRouteGuard.ɵfac = function NgxFeatureToggleRouteGuard_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || NgxFeatureToggleRouteGuard)(i0.ɵɵinject(i1.Router));
  };
  NgxFeatureToggleRouteGuard.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: NgxFeatureToggleRouteGuard,
    factory: NgxFeatureToggleRouteGuard.ɵfac,
    providedIn: 'root'
  });
  return NgxFeatureToggleRouteGuard;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of ngx-feature-toggle
 */

/**
 * Generated bundle index. Do not edit.
 */

export { FeatureToggleDirective, FeatureToggleModule, FeatureToggleProviderComponent, NgxFeatureToggleRouteGuard };
